import { koComponent } from "../../../../ko-utils";
import { getServerSideData } from "../../../page";
import ItemBase from "./itemBase";
import generateTextForSupportedLanguages from "../../../../utils/generateTextForSupportedLanguages";
import { ButtonItemDescriptor } from "../../../../site-config/config";

class BtnItemGroup extends ItemBase {
    constructor(params) {
        super(params);

        this.selectedLanguage = this.params.selectedLanguage;
    }

    addItem(type) {
        const newItem = new ButtonItemDescriptor();
        newItem.type(type);
        this.root.subs.push(newItem);

        this.openDetail(newItem);
    }

    openDetail(item) {
        let component = '';
        switch (ko.unwrap(item.type)) {
            case 'tour':
                component = 'btn-item-tour';
                break;
            case 'link':
                component = 'btn-item-link';
                break;
        }
        this.params.dialogApi.show('Edit Item', component, {
            item: item,
            selectedLanguage: this.selectedLanguage,
            simpleMode: true
        },
            (closeFn) => {
                closeFn();
            });
    }
}

export default koComponent('btn-item-grp', BtnItemGroup);